var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('data-section',{attrs:{"theme":"green","title":"國泰人壽團險","datas":_vm.datas,"_fields":[
      { name: '保單號碼', key: 'policynumber', width: 195,
        sortable: true,
        orderByMultiKey: ['policynumber'],
        orderByMultiType: ['asc'] },
      {
        name: '要保人',
        key: 'comp_name',
        width: 349,
        sortable: true,
        orderByMultiKey: ['comp_name'],
        orderByMultiType: ['asc']
      },
      {
        name: '被保人',
        key: 'insd_name',
        width: 94,
        sortable: true,
        orderByMultiKey: ['insd_name'],
        orderByMultiType: ['asc'],
      },
      {
        name: '投保身分',
        key: 'relation',
        width: 94,
        sortable: true,
        orderByMultiKey: ['relation'],
        orderByMultiType: ['asc'],
      },
      {
        name: '保險計畫/等級',
        key: 'class',
        width: 137,
      },
      {
        name: '有效期間',
        key: 'end_date',
        width: 110,
        sortable: true,
        orderByMultiKey: ['end_date'],
        orderByMultiType: ['asc'],
      }
    ].concat(_vm._fields),"initShow":_vm.$route.query['CathayGroupInsuranceShow'] !== 'false'},on:{"toggle":function (isShow) { return _vm.$router.assignQuery({ CathayGroupInsuranceShow: isShow }); }},scopedSlots:_vm._u([{key:"default",fn:function(props){return _vm.refresh?[_c('data-table',_vm._b({attrs:{"initSort":_vm.$route.query["CathayGroupInsuranceSort"]
          ? JSON.parse(_vm.$route.query["CathayGroupInsuranceSort"])
          : null},on:{"changeSort":function (sort) { return _vm.$router.assignQuery(( _obj = {}, _obj["CathayGroupInsuranceSort"] = JSON.stringify(sort), _obj ))
              var _obj;; }},scopedSlots:_vm._u([{key:"comp_name",fn:function(item){return [_c('div',[_c('div',[_vm._v("\n            "+_vm._s(item.data.comp_name)+"\n          ")])])]}},{key:"insd_name",fn:function(item){return [_c('div',[_c('div',[_vm._v("\n            "+_vm._s(_vm._f("truncate")(item.data.insd_name))+"\n          ")])])]}},{key:"relation",fn:function(item){return [_c('div',[_c('div',[_vm._v("\n            "+_vm._s(_vm.translate.relation[item.data.relation])+"\n          ")])])]}},{key:"end_date",fn:function(item){return [_c('div',{staticClass:"pre-formatted",domProps:{"innerHTML":_vm._s(
            _vm.buildStartEndString(
              _vm.getROCDate(item.data.c401_rdstdt),
              _vm.getROCDate(item.data.end_date)
            )
          )}})]}}])},'data-table',Object.assign({}, props, {
            datas: _vm.proccessDatas(props)
          }),false))]:undefined}}])})}
var staticRenderFns = []

export { render, staticRenderFns }